import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AvailableRcrTakedownListingsComponent } from './available-rcr-takedowns-container/available-rcr-takedown-listings/available-rcr-takedown-listings.component';
import { AvailableRcrTakedownsComponent } from './available-rcr-takedowns-container/available-rcr-takedowns.component';
import { CommittedExchangesContainerComponent } from './committed-exchanges-container/committed-exchanges-container.component';
import { CommittedExchangesListingsComponent } from './committed-exchanges-container/committed-exchanges-listings/committed-exchanges-listings.component';
import { ConfirmationComponent } from './confirmation-page/confirmation-page';
import { EnterBalancesComponent } from './enter-balances/enter-balances.component';
import { RCRRouteGuard } from './guards/rcrrouteguard';
import { TakedownRouteGuard } from './guards/TakedownRouteGuard';
import { RcrExchangeContainerComponent } from './rcr-exchange-container/rcr-exchange-container.component';
import { ContactListComponent } from './reports/contact-list/contact-list.component';
import { RcrVolumeReportComponent } from './reports/rcr-volume-report/rcr-volume-report.component';
import { ValidateArmPoolComponent } from './reports/validate-arm-pool/validate-arm-pool.component';
import { JumegaReportComponent } from './reports/jumega-report/jumega-report.component';
import { RequestAnExchangeLookupComponent } from './request-an-exchange-lookup/request-an-exchange-lookup.component';
import { ReviewAndCommitComponent } from './review-and-commit/review-and-commit.component';
import { CanDeactivateGuardService } from './services/can-deactivate-guard.service';
import { PassdataService } from './services/passdata.service';
import { RecombinationsService } from './services/recombinations.service';
import { SettledExchangesContainerComponent } from './settled-exchanges-container/settled-exchanges-container.component';
import { SettledExchangesListingsComponent } from './settled-exchanges-container/settled-exchanges-listings/settled-exchanges-listings.component';
import { RecombinationResolveService } from './shared/recombination-resolve.service';
import { PricingFileUploadComponent } from './stpricingupload/pricing-file-upload/pricing-file-upload.component';
import { UpdateBannerComponent } from './update-banner/update-banner.component';

const rcrFeatureRoutes: Routes = [
  {
    path: 'rcr-exchange',
    component: RcrExchangeContainerComponent,
    children: [
      {
        path: '',
        canActivateChild: [RCRRouteGuard],
        children: [
          {
            path: 'lookup',
            component: RequestAnExchangeLookupComponent,
          },
          {
            path: ':id/enter-balances',
            component: EnterBalancesComponent,
            canDeactivate: [CanDeactivateGuardService],
            resolve: {
              recombinations: RecombinationResolveService,
            },
          },
          {
            path: ':id/enter-balances/review-and-commit',
            component: ReviewAndCommitComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: ':id/enter-balances/review-and-commit/confirmation',
            component: ConfirmationComponent,
            canDeactivate: [CanDeactivateGuardService],
            data: [
              {
                isSettledExchangeConfirmation: false,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'rcr-exchange/rcr-takedown',
    component: AvailableRcrTakedownsComponent,
    canActivateChild: [TakedownRouteGuard],
    children: [
      {
        path: '',
        component: AvailableRcrTakedownListingsComponent,
      },
      {
        path: ':id/enter-takedowns',
        component: EnterBalancesComponent,
        resolve: {
          recombinations: RecombinationResolveService,
        },
      },
      {
        path: ':id/enter-takedowns/review-and-commit',
        component: ReviewAndCommitComponent,
        canDeactivate: [CanDeactivateGuardService],
      },
      {
        path: ':id/enter-takedowns/review-and-commit/confirmation',
        component: ConfirmationComponent,
        canDeactivate: [CanDeactivateGuardService],
        data: [
          {
            isSettledExchangeConfirmation: false,
          },
        ],
      },
    ],
  },
  {
    path: 'rcr-exchange/settled-exchanges',
    component: SettledExchangesContainerComponent,
    children: [
      {
        path: '',
        component: SettledExchangesListingsComponent,
      },
      {
        path: ':id/confirm',
        component: ConfirmationComponent,
        data: [
          {
            isSettledExchangeConfirmation: true,
          },
        ],
      },
    ],
  },
  {
    path: 'rcr-exchange/committed-exchanges',
    component: CommittedExchangesContainerComponent,
    children: [
      {
        path: '',
        component: CommittedExchangesListingsComponent,
      },
      {
        path: ':id/confirm',
        component: ConfirmationComponent,
        data: [
          {
            isSettledExchangeConfirmation: true,
          },
        ],
      },
    ],
  },
  {
    path: 'update-banner',
    component: UpdateBannerComponent,
  },
  {
    path: 'reports',
    children: [
      {
        path: '',
        children: [
          {
            path: 'rcr-monthly-volume-report',
            component: RcrVolumeReportComponent,
            canDeactivate: [CanDeactivateGuardService],
          },

          {
            path: 'active-users-report',
            component: ContactListComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'validate-arm-pool',
            component: ValidateArmPoolComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
          {
            path: 'ju-mega',
            component: JumegaReportComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
        ],
      },
    ],
  },
  {
    path: 'stpricingupload',
    children: [
      {
        path: '',
        children: [
          {
            path: 'pricing-file-upload',
            component: PricingFileUploadComponent,
            canDeactivate: [CanDeactivateGuardService],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(rcrFeatureRoutes)],
  providers: [PassdataService, RecombinationsService],
  exports: [RouterModule],
})
export class RCRExchangeRoutingModule {}
